//OEM PAGE
import React, { Component, Fragment } from "react";
import ToggleButton from "../../../libraries/ToggleButton";
import { ButtonCirclePlus } from "components/Common/Buttons";
import { plus } from "react-icons-kit/icomoon/plus";
import SvgIcon from "react-icons-kit";
import { Icon } from "react-icons-kit";
import { ic_settings } from "react-icons-kit/md/ic_settings";
import { cog } from "react-icons-kit/icomoon/cog";
import { ic_visibility } from "react-icons-kit/md/ic_visibility";
import { ic_delete } from "react-icons-kit/md/ic_delete";
import CreateOEM from "./CreateNewOEM/CreateOEM";
import "./OEMPage.css";
import { CRUDFunction } from "../../../reduxCURD/container";
import { printer } from "react-icons-kit/icomoon/printer";
import { curdActions } from "../../../reduxCURD/actions";
import { ToastService } from "../../../utils/toastify";
import ViewOemReport from "../../LocomotiveOEMRecord/viewOEMReport/ViewOemReport";
import ViewOEM from "./ViewOEMTable";
import ConfirmationDialog from "../../../libraries/ConfirmationDialog";
import { loop } from "react-icons-kit/icomoon/loop";
import ViewReportOfOEMContainer from "./ViewReport/ViewReport";
import { ic_keyboard_arrow_right } from "react-icons-kit/md/ic_keyboard_arrow_right";
import { ic_keyboard_arrow_down } from "react-icons-kit/md/ic_keyboard_arrow_down";
import TooltipContainer from "../../../libraries/TooltipContainer";
import { languageService } from "../../../Language/language.service";
import { MyButton } from "../../Common/Forms/formsMiscItems";
import { themeService } from "../../../theme/service/activeTheme.service";
import { ButtonStyle } from "../../../style/basic/commonControls";
class OEMPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      confirmationDialog: null,
      openCreateOEM: false,
      openOEMList: false,
      oemList: [],
      viewOEM: {
        open: false,
        oem: null,
      },
    };

    this.handleConfigure = this.handleConfigure.bind(this);
    this.handleViewOEM = this.handleViewOEM.bind(this);
    this.callbackAfterOEMisCreated = this.callbackAfterOEMisCreated.bind(this);
    this.handleUnConfigure = this.handleUnConfigure.bind(this);
  }

  async getOEMList() {
    const { getApplicationlookupss } = this.props;
    let result = await getApplicationlookupss("/getlist/MaintenanceOEM");
    this.setState({
      oemList: result.response,
    });
    this.refetchAssetData = this.refetchAssetData.bind(this);
  }
  async refetchAssetData() {
    await this.props.reFetchAsset();
  }
  componentDidMount() {
    this.getOEMList();
  }

  componentDidUpdate(prevProps) {
    const { actionType } = this.props;
    if (actionType != prevProps.actionType && actionType === "OEMDATA_UPDATE_FAILURE") {
      ToastService.Error("OEM operation failed.", "");
    }
    if (actionType != prevProps.actionType && actionType === "OEMDATA_UPDATE_SUCCESS") {
      // ToastService.Success("OEM operation successful.", "");
      this.refetchAssetData();
    }
  }
  async callbackAfterOEMisCreated(createdOEM) {
    await this.handleConfigure(createdOEM);
    await this.getOEMList();
  }

  async handleConfigure(selectedOEM) {
    const { selectedAsset } = this.props;

    try {
      const updatedAsset = { ...selectedAsset };
      if (!updatedAsset.OEMDetails) {
        updatedAsset.OEMDetails = { code: selectedOEM.code };
        await this.props.updateOEMData(updatedAsset, `update-oem/${selectedAsset._id}`);
        ToastService.Success("OEM configured successfully.", "");
      }
    } catch (e) {
      console.log(e);
    }
  }
  async handleUnConfigure() {
    const { selectedAsset } = this.props;

    try {
      const updatedAsset = { ...selectedAsset };
      if (updatedAsset.OEMDetails) {
        delete updatedAsset.OEMDetails;
        await this.props.updateOEMData(updatedAsset, `update-oem/${selectedAsset._id}`);
        ToastService.Success("OEM un-configured successfully.", "");
      }
    } catch (e) {
      console.log(e);
    }
  }
  handleViewOEM(selectedOEM) {
    this.setState({
      viewOEM: {
        open: true,
        oem: selectedOEM.opt2,
      },
    });
  }

  getOEMData() {
    const { oemList } = this.state;
    const { selectedAsset } = this.props;
    if (selectedAsset && selectedAsset.OEMDetails) {
      let f = oemList.find((e) => e.code === selectedAsset.OEMDetails.code);
      if (f) return f;
    }
    return null;
  }

  render() {
    const { selectedAsset } = this.props;
    const tableOEM = this.getOEMData();

    return (
      <div className="VOU_Container">
        <div>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "baseline", marginBottom: "1px solid #00000033" }}>
            <h3 className="VOU_Header" style={{ border: "none" }}>
              OEM MAINTENANCE
            </h3>
            {selectedAsset.OEMDetails && <FloatingDropdown handleUnConfigure={this.handleUnConfigure} />}
          </div>
          <hr />
        </div>

        {!selectedAsset.OEMDetails && (
          <Fragment>
            <div className="oemContainer">
              <h5>No OEM Maintenance Configured</h5>
              <MyButton type="button" style={themeService(ButtonStyle.commonButton)} onClick={() => this.setState({ openOEMList: true })}>
                {languageService("Configure")}
              </MyButton>
            </div>

            {this.state.openOEMList && (
              <div className="listoem">
                <h5 className="oem-title">OEM List</h5>
                <ul className="oem-list">
                  {this.state.oemList.map((e, i) => (
                    <li key={i} className="oem-item">
                      {e.opt2.title || e.code}
                      <div className="icon-container">
                        <TooltipContainer tooltipText={languageService("Configure")}>
                          <span className="icon" onClick={() => this.handleConfigure(e)}>
                            <Icon icon={plus} size={18} />
                          </span>
                        </TooltipContainer>
                        <TooltipContainer tooltipText={languageService("View")}>
                          <span className="icon" onClick={() => this.handleViewOEM(e)}>
                            <Icon icon={ic_visibility} size={20} />
                          </span>
                        </TooltipContainer>
                      </div>
                    </li>
                  ))}
                  <div className="oem-button-wrapper">
                    <TooltipContainer tooltipText={languageService("Create new OEM")}>
                      <ButtonCirclePlus
                        iconSize={30}
                        icon={plus}
                        customClassName={"road"}
                        backgroundColor="#e3e9ef"
                        margin="5px 0px 0px 0px"
                        borderRadius="50%"
                        hoverBackgroundColor="#e3e2ef"
                        hoverBorder="0px"
                        activeBorder="3px solid #e3e2ef"
                        iconStyle={{
                          color: "#c4d4e4",
                          background: "var(--fifth)",
                          borderRadius: "50%",
                          border: "3px solid ",
                        }}
                        handleClick={() => {
                          this.setState({ openCreateOEM: true });
                        }}
                      />
                    </TooltipContainer>
                  </div>
                </ul>
              </div>
            )}
          </Fragment>
        )}

        {selectedAsset.OEMDetails && this.state.oemList.length > 0 && (
          <ViewReportOfOEMContainer selectedAsset={selectedAsset} OEMData={this.getOEMData()} />
        )}

        {this.state.openCreateOEM && (
          <CreateOEM
            isOpen={this.state.openCreateOEM}
            close={() => this.setState({ openCreateOEM: false })}
            oemCreated={this.callbackAfterOEMisCreated}
          />
        )}

        {this.state.viewOEM.open && (
          <ViewOEM
            selectedAsset={this.props.selectedAsset}
            OEMData={this.state.viewOEM.oem}
            isOpen={this.state.viewOEM.open}
            onClose={() => this.setState({ viewOEM: { open: false, oem: this.state.viewOEM.oem } })}
          />
        )}
      </div>
    );
  }
}

const getApplicationlookupss = curdActions.getApplicationlookupss;

let actionOptions = {
  create: false,
  update: true,
  read: true,
  delete: false,
  others: {
    getApplicationlookupss: getApplicationlookupss,
  },
};

let variables = {
  applicationlookupsReducer: {
    applicationlookupss: [],
  },
};

const OEMpage = CRUDFunction(OEMPage, "OEMData", actionOptions, variables, ["applicationlookupsReducer"], "oem");

export default OEMpage;

class FloatingDropdown extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isDropdownOpen: false,
    };
  }

  toggleDropdown = () => {
    this.setState((prevState) => ({
      isDropdownOpen: !prevState.isDropdownOpen,
    }));
  };

  render() {
    const { isDropdownOpen } = this.state;
    return (
      <div className="dropdown-container123">
        <button className="dropdown-button123" onClick={this.toggleDropdown}>
          <SvgIcon icon={cog} size={20} />
          <span style={{ marginInlineStart: "10px" }}>{"   "}</span>
          {isDropdownOpen ? <SvgIcon icon={ic_keyboard_arrow_down} size={20} /> : <SvgIcon icon={ic_keyboard_arrow_right} size={20} />}
        </button>
        {isDropdownOpen && (
          <div className="dropdown-menu123">
            <div
              className="dropdown-item123"
              onClick={() => {
                this.toggleDropdown();
                this.props.handleUnConfigure();
              }}
            >
              Un-Configure OEM
            </div>
          </div>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/AssetView/OEM/OEMPage.jsx